import React from 'react';

interface SearchFiltersProps {
  filters: any;
  onFilterChange: (filters: any) => void;
}

const SearchFilters: React.FC<SearchFiltersProps> = ({ filters, onFilterChange }) => {
  const handleFilterChange = (key: string, value: any) => {
    onFilterChange({ [key]: value });
  };

  const handleArrayFilterChange = (key: string, value: any, checked: boolean) => {
    const currentArray = filters[key] || [];
    let newArray;
    
    if (checked) {
      newArray = [...currentArray, value];
    } else {
      newArray = currentArray.filter((item: any) => item !== value);
    }
    
    onFilterChange({ [key]: newArray });
  };

  return (
    <div className="bg-white rounded shadow-sm p-3">
      <h6 className="mb-3 fw-bold">検索条件</h6>
      
      {/* キーワード検索 */}
      <div className="mb-3">
        <label className="form-label fw-bold">キーワード</label>
        <input
          type="text"
          className="form-control"
          placeholder="例) PHP 渋谷"
          value={filters.keyword || ''}
          onChange={(e) => handleFilterChange('keyword', e.target.value)}
        />
      </div>

      {/* 価格帯 */}
      <div className="mb-3">
        <label className="form-label fw-bold">単価</label>
        <select
          className="form-select"
          value={filters.price_range || ''}
          onChange={(e) => handleFilterChange('price_range', e.target.value)}
        >
          <option value="">単価を選択してください</option>
          <option value="under_300000">30万円未満</option>
          <option value="300000_and_above">30万円以上</option>
          <option value="400000_and_above">40万円以上</option>
          <option value="500000_and_above">50万円以上</option>
          <option value="600000_and_above">60万円以上</option>
          <option value="700000_and_above">70万円以上</option>
          <option value="800000_and_above">80万円以上</option>
        </select>
      </div>

      {/* 勤務スタイル */}
      <div className="mb-3">
        <label className="form-label fw-bold">勤務スタイル</label>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="remote"
            checked={filters.workstyle_types?.includes('remote') || false}
            onChange={(e) => handleArrayFilterChange('workstyle_types', 'remote', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="remote">
            リモート可
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="full_remote"
            checked={filters.workstyle_types?.includes('full_remote') || false}
            onChange={(e) => handleArrayFilterChange('workstyle_types', 'full_remote', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="full_remote">
            フルリモート
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="onsite"
            checked={filters.workstyle_types?.includes('onsite') || false}
            onChange={(e) => handleArrayFilterChange('workstyle_types', 'onsite', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="onsite">
            常駐
          </label>
        </div>
      </div>

      {/* 勤務可能日数 */}
      <div className="mb-3">
        <label className="form-label fw-bold">勤務可能日数</label>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="one_day"
            checked={filters.availability_types?.includes('one_day_in_a_week') || false}
            onChange={(e) => handleArrayFilterChange('availability_types', 'one_day_in_a_week', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="one_day">
            週1日
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="two_days"
            checked={filters.availability_types?.includes('two_days_in_a_week') || false}
            onChange={(e) => handleArrayFilterChange('availability_types', 'two_days_in_a_week', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="two_days">
            週2日
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="three_days"
            checked={filters.availability_types?.includes('three_days_in_a_week') || false}
            onChange={(e) => handleArrayFilterChange('availability_types', 'three_days_in_a_week', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="three_days">
            週3日
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="four_days"
            checked={filters.availability_types?.includes('four_days_in_a_week') || false}
            onChange={(e) => handleArrayFilterChange('availability_types', 'four_days_in_a_week', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="four_days">
            週4日
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="five_days"
            checked={filters.availability_types?.includes('five_days_in_a_week') || false}
            onChange={(e) => handleArrayFilterChange('availability_types', 'five_days_in_a_week', e.target.checked)}
          />
          <label className="form-check-label" htmlFor="five_days">
            週5日
          </label>
        </div>
      </div>

      {/* 新着案件 */}
      <div className="mb-3">
        <label className="form-label fw-bold">新着案件</label>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="published_within_7"
            checked={filters.published_within === 7}
            onChange={(e) => handleFilterChange('published_within', e.target.checked ? 7 : undefined)}
          />
          <label className="form-check-label" htmlFor="published_within_7">
            直近7日以内
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="published_within_30"
            checked={filters.published_within === 30}
            onChange={(e) => handleFilterChange('published_within', e.target.checked ? 30 : undefined)}
          />
          <label className="form-check-label" htmlFor="published_within_30">
            直近30日以内
          </label>
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;
